module.exports = __webpack_public_path__ + "media/images/button-mask-1c03290868cf2383218c752058bdcdf2.svg";